import { usePhoneCampaign } from '@hc-frontend/core-ui';
import { CallCampaignPhoneAndScheduleWithIcon } from '@hc-frontend/shells-shared';

export default function HeaderCallComponent() {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <CallCampaignPhoneAndScheduleWithIcon
        phoneCampaign={phoneCampaign}
        iconUrl="https://d9hhrg4mnvzow.cloudfront.net/welcome.healthcare.com/medicare/contact/medicare-advantage/81db80e2-agenticon.svg"
      />
    );
  }
  return null;
}
